export default __webpack_public_path__ + "static/media/toast-succes.d18614fd.svg";